(() => {
  const loaded = { analytics: false, advertising: false };
  let reloading = false;

  const appendScript = (src) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  };

  const loadAnalytics = () => {
    if (loaded.analytics) return;
    loaded.analytics = true;
    window.hj = window.hj || function () {
      (window.hj.q = window.hj.q || []).push(arguments);
    };
    window._hjSettings = { hjid: 3016258, hjsv: 6 };
    appendScript('https://static.hotjar.com/c/hotjar-3016258.js?sv=6');
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    appendScript('https://www.clarity.ms/tag/jcwuje8n2i');
  };

  const loadAdvertising = () => {
    if (loaded.advertising) return;
    loaded.advertising = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    appendScript('https://www.googletagmanager.com/gtm.js?id=GTM-KP6QQQ9');
  };

  const applyConsent = () => {
    let consent;
    try {
      consent = window.Shopify?.customerPrivacy?.currentVisitorConsent();
    } catch (_) {
      consent = null;
    }
    const analytics = consent?.analytics === 'yes';
    const advertising = analytics && consent?.marketing === 'yes';
    if ((loaded.analytics && !analytics) || (loaded.advertising && !advertising)) {
      if (reloading) return;
      reloading = true;
      window.location.reload();
      return;
    }
    if (analytics) loadAnalytics();
    if (advertising) loadAdvertising();
  };

  document.addEventListener('visitorConsentCollected', applyConsent);

  const initialize = (attempt = 0) => {
    if (window.Shopify?.customerPrivacy) {
      applyConsent();
      return;
    }
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) applyConsent();
      });
      return;
    }
    if (attempt < 10) window.setTimeout(() => initialize(attempt + 1), 500);
  };

  document.querySelectorAll('[data-alveroa-cookie-settings]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (typeof window.privacyBanner?.showPreferences !== 'function') return;
      event.preventDefault();
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {
        window.location.assign(link.href);
      });
    });
  });

  initialize();
})();
